import { LandingPage } from 'modules/landingPage';

import { Switch, Route, Redirect } from 'react-router-dom';
import { ContactPage } from 'modules/contactPage';
import { ContactPathsEnum } from 'modules/contactPage/routes';
import { LeasingCalculatorPathsEnum } from 'modules/leasingCalculator/routes';
import { LeasingCalculatorPage } from 'modules/leasingCalculator';
import { PasswordResetPage } from '../modules/passwordResetPage';
import { TfaNotifyActionSent } from '../modules/landingPage/components/notifyActions';
import { TfaNotifyActionResponse } from '../modules/landingPage/components/notifyActions/components/TfaNotifyActionResponse';
import { QrNotifyActionResponse } from '../modules/landingPage/components/notifyActions/components/QrNotifyActionResponse';
import { SimpleLeasingOfferOverviewPage } from '../modules/leasingOfferOverviewPage/components/simpleOfferOverviewPage';

export const LoggedOutRoutes = () => (
  <Switch>
    {/* landing page */}
    <Route path="/" component={LandingPage} exact />

    {/* register page */}
    {/* FRON-669 commented for release day
    <Route
      path="/register"
      exact
      render={() => (
        <Redirect to={getRegisterPageUrl(RegisterPagePathsEnum.userTypeForm)} />
      )}
    />
    <Route
      path="/register/:form/:step?"
      exact
      render={({ match }) => {
        const stepForm = Object.values(RegisterPagePathsEnum).find(
          (e) => e === match.params.form,
        );
        const matchParams: {
          stepForm?: RegisterPagePathsEnum;
          step?: number;
        } = {
          stepForm,
          step: stepForm && match.params.step ? +match.params.step : undefined,
        };
        return <RegisterUserPage {...matchParams} />;
      }}
    />
    <Route
      path="/register"
      exact
      render={() => (
        <Redirect to={getRegisterPageUrl(RegisterPagePathsEnum.userTypeForm)} />
      )}
    />
    */}

    {/* Contact Form */}
    <Route path={ContactPathsEnum.contactPage} component={ContactPage} exact />

    <Route
      path="/tfa-reset-notify-action"
      component={TfaNotifyActionSent}
      exact
    />

    <Route
      path="/reset-tfa-provider"
      component={TfaNotifyActionResponse}
      exact
    />

    <Route path="/reset-qr" component={QrNotifyActionResponse} exact />

    {/* Password Reset */}
    <Route path="/password-reset" exact component={PasswordResetPage} />

    {/* Leasing Calculator */}

    <Route
      path={LeasingCalculatorPathsEnum.leasingCalculator}
      exact
      render={() => <LeasingCalculatorPage showInfoCalculation />}
    />
    <Route
      path={`${LeasingCalculatorPathsEnum.leasingCalculator}/offer`}
      exact
      render={() => <SimpleLeasingOfferOverviewPage />}
    />
    {/* FRON-539 commented for release day */}
    {/*
    <Route
      path={`${LeasingCalculatorPathsEnum.leasingCalculator}/:step?/:tab?`}
      exact
      render={({ match }) => {
        const tabEnum = Object.values(LeasingOfferOverviewTab).find(
          (key) => key === match.params.tab,
        );

        const matchParams: {
          step?: number;
          tab?: LeasingOfferOverviewTab;
        } = {
          step: match.params.step ? +match.params.step : undefined,
          tab: tabEnum || undefined,
        };

        return <LeasingCalculatorPage {...matchParams} />;
      }}
    />
    */}

    <Redirect to="/" />
  </Switch>
);
